/** Who may see an opening. Stored on the job post as `visibility`; older openings have none. */
export type OpeningVisibility = 'public' | 'internal' | 'confidential'

/**
 * An opening's visibility, normalized: trimmed, lowercased, and `'public'` when missing or blank, so
 * openings saved before visibility existed read as Public. An unrecognised value is returned as-is
 * rather than coerced to Public — restriction checks compare `!== 'public'` and so fail closed on it.
 */
export function openingVisibilityOf(post?: { visibility?: string | null } | null): OpeningVisibility | string {
  return post?.visibility?.trim().toLowerCase() || 'public'
}
